module.exports = __webpack_public_path__ + "img/confirm.5d132718.svg";